(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.filter.trustHtml'

  angular
    .module(MODULE_NAME, [])
    .filter('trustHtml', ['$sce', function ($sce) {
      return $sce.trustAsHtml
    }])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/filter/trustHtml.js